import React from 'react';

import { EchoNavigate, EchoSlot, useEcho } from '@betterment/js-runtime';
import { Box } from '@betterment/samba-react';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';
import { useLoaderData } from 'react-router-dom';

import { BillingPlanCard } from './BillingPlanCard';
import { PortfolioControls } from './PortfolioControls';

import { FullPageLoader } from '../../FullPageLoader';
import { Layout } from '../../InstitutionalApp/Layout';
import { Header } from '../Header';

export const HouseholdSettingsEchoRoute: React.FC = () => {
  const { echo, onSubmit } = useEcho(useLoaderData());

  const householdId = useRequiredParam('householdId');

  if (echo.type === 'navigation') {
    return <EchoNavigate echo={echo} fallback={<FullPageLoader />} />;
  }

  return (
    <Layout active="clients">
      <Layout.Header>
        <Header />
      </Layout.Header>
      <Layout.Content>
        <Box css={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'space.400', pb: 'space.400' }}>
          <BillingPlanCard />
          <PortfolioControls householdId={householdId} />
        </Box>
        <EchoSlot slot={echo.slots.main!} onSubmit={onSubmit} />
      </Layout.Content>
    </Layout>
  );
};
